export default "__VITE_ASSET__DbwI1cDq__"